import { createApp } from 'vue';
import CalendarListVue from './calendar-list.vue';
import { waitForBootstrap } from '../../bootstrap-helpers';

export class CalendarList {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(CalendarListVue, this.props);
        waitForBootstrap(() => app.mount(el));
    }
}
